import { Component, OnDestroy, OnInit} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { VERSION } from 'app/app.constants';
import { AuthenticationService } from './core/security/authentication-service';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from './core/services/breadcrumb.service';


@Component({
  selector: 'app-root, jhi-main',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  // Adicione esta propriedade se ainda não existir
  homeItem: MenuItem = { routerLink: '/obrigacoes-acessorias' };
  breadcrumbItems: MenuItem[] = [
    { label: 'Home', icon: 'pi pi-home', routerLink: '/obrigacoes-acessorias' },
    { label: '', routerLink: '/current' }
  ];

  title = 'sfz-obrigacoes-acessorias-gateway';
  version = '';
  loggedInUsername$ = new BehaviorSubject<string>('');
  layoutDispositivoXs = true
  mediaSub: Subscription = new Subscription;

  constructor(public authService: AuthenticationService,
              public mediaObserver: MediaObserver,
              private breadcrumbService: BreadcrumbService) {
      this.breadcrumbService.breadcrumbs$.subscribe((items: MenuItem[]) => {
      this.breadcrumbItems = [...items];
    });

    if (VERSION) {
      this.version = VERSION;
    }
  }

  onBreadcrumbClick(event: { item: MenuItem, originalEvent: Event }): void {
    if (event.item.label === 'Portal do Contribuinte') {
      window.location.href = '/';
    }
  }

  ngOnInit(): void {
      this.mediaSub = this.mediaObserver.asObservable().subscribe((result:MediaChange[]) => {
        this.layoutDispositivoXs = result[0].mqAlias === 'xs' ? true : false;
      });
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
  }
}
